import { SearchUsersResponse } from '@/types/entities/users';
import { EntityTypesEnum } from '@/enums/EntityTypesEnum';

export const transformSearchUsersResponse = (data: SearchUsersResponse) => {
  const personUsers = data?.persons
    ? data.persons.map((item) => ({
        id: item.id,
        name: `${item.firstName.value} ${item.lastName.value}`,
        idNumber: item.socialSecurityNumber?.value ?? item.socialInsuranceNumber?.value ?? '',
        //TODO: remove after changing type for configurable entity
        //@ts-ignore
        idNumberType: item.socialSecurityNumber?.displayTitle ?? item.socialInsuranceNumber?.displayTitle ?? '',
        entityType: EntityTypesEnum.Person,
      }))
    : [];
  const businessUsers = data?.businesses
    ? data.businesses.map((item) => ({
        id: item.id,
        name: `${item.name.value}`,
        idNumber: item.tin.value,
        //@ts-ignore
        idNumberType: item.tin.displayTitle,
        entityType: EntityTypesEnum.Business,
      }))
    : [];

  const sortedUsers = [...personUsers, ...businessUsers].sort((a, b) => a.name.localeCompare(b.name));

  return sortedUsers;
};
